var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_Symbol.js
// module id = ./node_modules/react-touch/node_modules/lodash/_Symbol.js
// module chunks = main